import React from "react";
import { Heading, List, Icon } from "@telia/teddy";
import { SellingPoints } from "../../../../../../models";
import "./LinkList.less";

interface LinkListProps {
    sellingPoints?: SellingPoints[];
}

const LinkList: React.FC<LinkListProps> = ({ sellingPoints }) => {
    return (
        <div className="link-list">
            <hr />
            <List layout="vertical" className="link-list__list">
                {sellingPoints
                    ?.filter((point) => point.url)
                    .map((point) => (
                        <List.Item key={point.heading}>
                            <List.Content className="link-list__link-content">
                                <a href={point.url} className="link-list__link">
                                    <Heading
                                        mb="100"
                                        as={point.headingTag ?? "h2"}
                                        variant="title-100"
                                        className="link-list__link-heading"
                                    >
                                        {point.heading}
                                    </Heading>
                                    <Icon name="arrow-right" size="md" aria-hidden="true" focusable="false" />
                                </a>
                            </List.Content>
                        </List.Item>
                    ))}
            </List>
        </div>
    );
};

export default LinkList;
